import '~/js/modules/stickyNav';
import FamilySuites from '~/js/components/resorts/FamilySuites';
import '~/js/sections/weddings/includes/scroll-below';
import dataLayerProvider from '~/js/modules/resorts/datalayer-provider';

const { dataLayer = {} } = window.beaches_app.page;

dataLayerProvider.inject(dataLayer);

document.querySelector('.family-suites-link').addEventListener('click', () => {
  document.querySelector('.accommodations').scrollIntoView(
    {behavior: 'smooth', block: 'start'}
  );
});

ReactDOM.render(
  <FamilySuites
    resortCode = {beaches_app.page.resort.code}
    roomCodes = {['TWP', 'PP', 'G2', 'M2P', 'FWP', 'MP', 'NP', 'F3', 'P2', 'RW', 'S2', 'D2', 'R2', 'PW', 'T2', 'V2']}
  />,
  document.querySelector('#root')
);
